import styled from 'styled-components';

export const Wrapper = styled.div`
  background: url('/images/home/middle-bg-02.png') rgba(256, 256, 256, 0.1);
  background-size: cover;
  background-blend-mode: multiply;
`;